import {combineReducers} from 'redux';
import * as actionTypes from './actionTypes';
import {getDefaultDarkMode} from "../../utils/utils";

const initialState = {
    loading: false,
    sizeData: null,
    userConfiguration: {darkMode: getDefaultDarkMode()},
    currentLoginPage: "login"
};

const currentLoginPage = (state = initialState.currentLoginPage, action) => {
    switch (action.type) {
        case actionTypes.CHANGED_LOGIN_PAGE:
            return action.page;
        default:
            return state;
    }
}

const sizeData = (state = initialState.sizeData, action) => {
    switch (action.type) {
        case actionTypes.LOADED_USER_SIZE_DATA:
            return {
                ...action.sizeData,
                percentage: ((action.sizeData.currentSize / action.sizeData.totalSize) * 100).toFixed(2)
            };
        case actionTypes.DELETED_FILES_SIZE_DATA:
            const newSizeData = {...state};
            for (let file of action.files) {
                newSizeData.currentSize -= file.size;
            }
            return {...newSizeData, percentage: ((newSizeData.currentSize / newSizeData.totalSize) * 100).toFixed(2)};
        case actionTypes.ADDED_FILES_SIZE_DATA:
            const newSizeDataAdd = {...state};
            for (let file of action.files) {
                newSizeDataAdd.currentSize += file.size;
            }
            return {
                ...newSizeDataAdd,
                percentage: ((newSizeDataAdd.currentSize / newSizeDataAdd.totalSize) * 100).toFixed(2)
            };
        default:
            return state;
    }
}

const userConfiguration = (state = initialState.userConfiguration, action) => {
    switch (action.type) {
        case actionTypes.LOADED_USER_CONFIG:
            return {...action.config};
        case actionTypes.MANUALLY_SET_DARK_MODE:
            return {...state, darkMode: action.darkMode};
        default:
            return state;
    }
}

const loading = (state = initialState.loading, action) => {

    switch (action.type) {
        case actionTypes.LOADING:
            return true;
        case actionTypes.LOADED:
            return false;
        default:
            return state;
    }
}

const reducer = combineReducers({
    loading,
    sizeData,
    userConfiguration,
    currentLoginPage
});

export default reducer;
